export const projects = [
  {
    name: "GridMaster",
    render_free: false,
    id: 15,
    url: "https://ai-crossword.netlify.app/",
    imgOriginal: require("../images/gridmaster-1920.webp"),
    imgLarge: require("../images/gridmaster-792.webp"),
    imgMedium: require("../images/gridmaster-440.webp"),
    featured: true,
    src: "https://github.com/Hallelujah78/crossword-app",
    info: "With the click of a few buttons, a user can create their own crossword grid, generate answers, and use the OpenAI API to create clues. There is a route where the user can create their own crosswords and a separate route where they can solve crosswords they have created OR generate a new solvable crossword with the click of a single button.      Includes a custom onboarding/tutorial modal on the 'create' route. The tutorial modules allow the developer to specify their own steps, render text or their own custom components for each step, and also attach components, for example an arrow, to the part of the UI that the step is referring to.",
    tech: "React + TypeScript, Netlify serverless functions, OpenAI API, React, Vite, Biome",
  },
  {
    name: "Mystic Mindy",
    render_free: false,
    id: 16,
    url: "https://mysticmindy.netlify.app/",
    imgOriginal: require("../images/mindy-1920.webp"),
    imgLarge: require("../images/mindy-792.webp"),
    imgMedium: require("../images/mindy-440.webp"),
    featured: true,
    src: "https://github.com/Hallelujah78/mystic-mindy",
    info: "Another fun project completed over a few days as part of my level 7 diploma in applied software development. My clairvoyant dog tells your fortune with the help of AI! Inspired by a photo I have of my dog with what might be a vest tied over its head like a scarf.",
    tech: "Vanilla JS, HTML, CSS, Netlify serverless functions, Vite, Biome",
  },
  {
    name: "Country Insights",
    render_free: false,
    id: 11,
    url: "https://restcountries-react-front-end-node.onrender.com/",
    imgOriginal: require("../images/countryInsights-1920.webp"),
    imgLarge: require("../images/countryInsights-792.webp"),
    imgMedium: require("../images/countryInsights-440.webp"),
    featured: true,
    src: "https://github.com/Hallelujah78/BICodingChallenge",
    info: "I created this site over a three week period as part of a coding challenge for a potential paid internship position",
    tech: "HTML, CSS, JavaScript, React, Express, Node, REST API, Vite, Jest, React Testing Library, various React libraries including react-icons, react-select, react-toastify, react-use and react-tooltip",
  },
  {
    name: "Wurdil",
    render_free: false,
    id: 13,
    url: "https://wurdil.netlify.app/",
    imgOriginal: require("../images/wurdil-1920.webp"),
    imgLarge: require("../images/wurdil-792.webp"),
    imgMedium: require("../images/wurdil-440.webp"),
    featured: true,
    src: "https://github.com/Hallelujah78/wordle-clone",
    info: "A Wordle clone. Built primarily to create a project I might be able to recreate in different frameworks, as a portfolio project, and to practice TypeScript.",
    tech: "HTML, CSS, JavaScript, React, Vite, TypeScript, framer-motion, Cypress testing",
  },
  {
    name: "Driver Theory Test",
    render_free: false,
    id: 9,
    url: "https://driver-theory.onrender.com/landing",
    imgOriginal: require("../images/driver-theory-1920.webp"),
    imgLarge: require("../images/driver-theory-792.webp"),
    imgMedium: require("../images/driver-theory-440.webp"),
    featured: true,
    src: "https://github.com/Hallelujah78/driverTheory",
    info: "This is an approximate copy of the Road Safety Authority's Driver Theory mobile app. This project is now complete and I probably won't add additional functionality or more questions. Hosted on Render's Starter tier, so there is no waiting for Render to spin it up. It's called DriveL because I find it funny.",
    tech: "NodeJS, Express, Postman, MongoDB Atlas, Mongoose, SendGrid, ReactJS",
  },
  {
    name: "Image Grid Animation",
    render_free: false,
    id: 14,
    url: "https://grid-animation.netlify.app/",
    imgOriginal: require("../images/grid-animation-1920.webp"),
    imgLarge: require("../images/grid-animation-792.webp"),
    imgMedium: require("../images/grid-animation-440.webp"),
    featured: true,
    src: "https://github.com/Hallelujah78/explosion-framer-motion",
    info: "Built to play around with framer motion. 1014 image tiles are translated offscreen when a user clicks on the screen. Originally built using equation of a line but ultimately ended up using vector math. Best viewed on a tablet, laptop or desktop as it is not responsive - the image tiles are fixed at 20px squares with the image fixed at 780px by 520px",
    tech: "HTML, CSS, JavaScript, React, Vite, TypeScript, framer-motion",
  },
  {
    name: "Webstore",
    render_free: false,
    id: 1,
    url: "https://webstore-gwib.netlify.app/index.html",
    imgOriginal: require("../images/comfy-1920.webp"),
    imgLarge: require("../images/comfy-792.webp"),
    imgMedium: require("../images/comfy-440.webp"),
    featured: false,
    src: "https://github.com/Hallelujah78/comfy",
    info: "I created this functioning webstore app as part of a Udemy course",
    tech: "HTML, CSS, JavaScript, dynamically created product pages, API, JSON, shopping cart, fully responsive, mobile first",
  },
  {
    name: "JW Browne Electrical - '23 update",
    render_free: false,
    id: 2,
    url: "https://www.jwbelectrical.ie/",
    imgOriginal: require("../images/jwbelectrical2023-1920.webp"),
    imgLarge: require("../images/jwbelectrical2023-792.webp"),
    imgMedium: require("../images/jwbelectrical2023-440.webp"),
    featured: true,
    src: "",
    info: "I created this website for my brother's business in 2019. This is the updated 2023 version. Since I had just completed a Webpack 5 course, I used webpack 5 to minify the HTML, CSS and JS. Rewrote the CSS from scratch, added a jump to top button, added smooth scrolling when jumping to different sections, amongst other things. It's also a PWA. Images are webp or SVG.",
    tech: "HTML, CSS, JavaScript, fully responsive, Flexbox, Grid, Webpack 5",
  },
  {
    name: "Markdown Previewer",
    render_free: false,
    id: 3,
    url: "https://markdown-previewer-gwib.netlify.app/",
    imgOriginal: require("../images/react-markdown-previewer-1920.webp"),
    imgLarge: require("../images/react-markdown-previewer-792.webp"),
    imgMedium: require("../images/react-markdown-previewer-440.webp"),
    featured: false,
    src: "https://github.com/Hallelujah78/markdown-previewer",
    info: "I created this project from scratch using React as part of my work on Free Code Camp's curriculum",
    tech: "React, HTML, CSS, JavaScript, fully responsive, mobile first",
  },
  {
    name: "Tints & Shades",
    render_free: false,
    id: 4,
    url: "https://gwib-tints-and-shades.netlify.app/",
    imgOriginal: require("../images/tints-and-shades-1920.webp"),
    imgLarge: require("../images/tints-and-shades-792.webp"),
    imgMedium: require("../images/tints-and-shades-440.webp"),
    featured: true,
    src: "https://github.com/Hallelujah78/color-generator",
    info: "This is my first 'from scratch' project having completed John Smilga's Styled Components V5 course on Udemy. It allows users to generate tints and shades and copy global color variables into their own projects. Added a relative luminance calculation that is used to determine whether black or white text would provide the best contrast ratio. Font color is then set dynamically.",
    tech: "HTML, CSS, JavaScript, React, Styled Components, fully responsive, mobile first",
  },
  {
    name: "Klingon Ipsum",
    render_free: false,
    id: 5,
    url: "https://gwib-klingon-ipsum-react.netlify.app/",
    imgOriginal: require("../images/klingon-1920.webp"),
    imgLarge: require("../images/klingon-792.webp"),
    imgMedium: require("../images/klingon-440.webp"),
    featured: true,
    src: "https://github.com/Hallelujah78/klingon-ipsum",
    info: "A fun little project inspired by Hipster Ipsum. I took a list of Klingon words and created a fake API on Postman. It first creates sentences of a random length and then creates paragraphs of a random length.",
    tech: "HTML, CSS, JavaScript, React, fully responsive, mobile first, API, Postman",
  },
  {
    name: "Random Pictures",
    render_free: false,
    id: 6,
    url: "https://gwib-random-picture-react.netlify.app/",
    imgOriginal: require("../images/random-picture-1920.webp"),
    imgLarge: require("../images/random-picture-792.webp"),
    imgMedium: require("../images/random-picture-440.webp"),
    featured: false,
    src: "https://github.com/Hallelujah78/random-pictures",
    info: "Another project I created from scratch. This was a challenging project that combines a fetch request to Lorem Picsum with useReducer and useContext",
    tech: "HTML, CSS, JavaScript, React, fully responsive, mobile first, API, useReducer, useContext, React Router",
  },
  {
    name: "Simple Auth API",
    render_free: true,
    id: 7,
    url: "https://simple-auth-api.onrender.com/",
    imgOriginal: require("../images/simpleAuthAPI-1920.webp"),
    imgLarge: require("../images/simpleAuthAPI-792.webp"),
    imgMedium: require("../images/simpleAuthAPI-440.webp"),
    featured: false,
    src: "https://github.com/Hallelujah78/mcqAPI",
    info: "This is based on John Smilga's Jobs API project from his NodeJS course. I added a deleteAccount option and a restricted dashboard route to demonstrate that authentication is working. I kept it simple so that I can reuse it in later portfolio projects. It is hosted on Render.com's free tier and so will take time to spin up!",
    tech: "Node.js, Express, Swagger UI, APIMatic, Postman, MongoDB Atlas, Mongoose.",
  },
  {
    name: "MERN Stack Jobify",
    render_free: true,
    id: 8,
    url: "https://mern-jobify-cookies.onrender.com/landing",
    imgOriginal: require("../images/MERNJobify-1920.webp"),
    imgLarge: require("../images/MERNJobify-792.webp"),
    imgMedium: require("../images/MERNJobify-440.webp"),
    featured: false,
    src: "https://github.com/Hallelujah78/MERN-Jobify-JWT-cookies",
    info: "This is based on John Smilga's Jobify project from his MERN stack course. I added various features including account verification via email and reset password functionality via email. It is hosted on Render.com's free tier and so will take time to spin up!",
    tech: "NodeJS, Express, Postman, MongoDB Atlas, Mongoose, SendGrid",
  },

  {
    name: "JW Browne Electrical Website - 2019 version",
    render_free: false,
    id: 10,
    url: "https://jwbelectrical-2019-old.netlify.app/",
    imgOriginal: require("../images/JWB-Electrical-Webpage-1920.webp"),
    imgLarge: require("../images/JWB-Electrical-Webpage-792.webp"),
    imgMedium: require("../images/JWB-Electrical-Webpage-440.webp"),
    featured: false,
    src: "",
    info: "The original version of my brother's website I created in 2019.",
    tech: "HTML, CSS, JavaScript, fully responsive",
  },
  {
    name: "Quote 'n' Tweet",
    render_free: false,
    id: 12,
    url: "https://react-ts-quote-n-tweet.netlify.app/",
    imgOriginal: require("../images/quote-n-tweet-1920.webp"),
    imgLarge: require("../images/quote-n-tweet-792.webp"),
    imgMedium: require("../images/quote-n-tweet-440.webp"),
    featured: false,
    src: "https://github.com/Hallelujah78/Quote-n-Tweet",
    info: "Revisiting a very early React project to practice using TypeScript and Cypress testing. Get a random quote and tweet it",
    tech: "TypeScript, React, Cypress, AbortController, Vite, react-icons, styled-reset, styled-components",
  },
];
